export const ROLE_LABELS = {
  org_owner: "Organization Owner",
  org_admin: "Organization Admin",
  billing_admin: "Billing Admin",
  team_lead: "Team Lead",
  user: "Team Member",
};

export const isOrgManagerRole = (role) => role === "org_owner" || role === "org_admin";
